<template>
  <g transform="translate(0,0) matrix(0.95 0 0 0.95 0 0)">
    <path
      d="M5.5 11.5L6.35576 17.9182C6.41231 18.3423 6.94081 18.5041 7.22508 18.1843L10.1811 14.8587C10.3593 14.6583 10.6639 14.6341 10.8715 14.8039L14.7429 17.9715C15.3194 18.4432 16.1908 18.1416 16.3523 17.4145L19.5973 2.81234C19.77 2.03503 19.0092 1.37745 18.2651 1.66092L1.4413 8.06998C0.584095 8.39654 0.582161 9.60852 1.43832 9.93782L5.5 11.5ZM5.5 11.5L13.8689 6.89709C14.1675 6.7329 14.4652 7.11443 14.2333 7.36409L9.12659 12.8637C9.04291 12.9538 8.97658 13.0586 8.93091 13.1727L7 18"
      stroke="#FFFEF4"
      stroke-width="1.2"
    />
  </g>
</template>
